module.exports = __webpack_public_path__ + "img/logo-eng-2x.5faf514a.png";